import type * as Types from 'app/types/graphql';

export type ColumnSelectFragment = Pick<Types.Column, 'dataType' | 'displayName' | 'name'>;

export type TableDataSelectFragment = Pick<Types.TableData, 'rows'> & {
  columns?: Types.Maybe<
    Array<Types.Maybe<Pick<Types.Column, 'dataType' | 'displayName' | 'name'>>>
  >;
};

export type GemXqlResultSelectFragment = {
  tableData?: Types.Maybe<
    Pick<Types.TableData, 'rows'> & {
      columns?: Types.Maybe<
        Array<Types.Maybe<Pick<Types.Column, 'dataType' | 'displayName' | 'name'>>>
      >;
    }
  >;
};

export const ColumnSelectFragmentDoc = `
    fragment ColumnSelect on Column {
  dataType
  displayName
  name
}
    `;
export const TableDataSelectFragmentDoc = `
    fragment TableDataSelect on TableData {
  columns {
    ...ColumnSelect
  }
  rows
}
    `;
export const GemXqlResultSelectFragmentDoc = `
    fragment GemXQLResultSelect on GemxQLResult {
  tableData {
    ...TableDataSelect
  }
}
    `;
